import owd from 'owd/owd';
import browser from 'owd/utils/browser';

export default class Fix100vh extends owd.Component {
	init() {
		if (browser.isIOS()) {
            this.$element.css({
                height: window.innerHeight
            });
        }
	}
}

owd.registerComponent('fix-100vh', {
	component: Fix100vh
});
